import { Referral } from '@umss/shared/data-access';

export const MOCK_REFERRALS: Referral[] = [
  {
    referredId: '3f2c9b6e-7a4b-4f8a-9e3a-1b7a2c6d91e4',
    referredName: 'Jacob Miller',
    totalHoursWorked: 1240,
    hoursWorkedThisWeek: 38,
    joinDate: '2023-02-15',
    totalEarnings: 37200,
  },
  {
    referredId: 'a8d4e1c2-5b9f-4a73-8c41-6f2e9d0b7c55',
    referredName: 'Emily Johnson',
    totalHoursWorked: 860,
    hoursWorkedThisWeek: 42,
    joinDate: '2023-08-03',
    totalEarnings: 25800,
  },
  {
    referredId: 'c91e5a74-2d6f-4e3b-9f28-0a7d6c5b1e92',
    referredName: 'Michael Anderson',
    totalHoursWorked: 1560,
    hoursWorkedThisWeek: 40,
    joinDate: '2022-11-20',
    totalEarnings: 46800,
  },
];

export const MOCK_SUMMARY = {
  earningsThisWeek: 13,
  hoursThisWeek: 50,
  totalEarningsAllTime: 450,
  totalReferrals: 2,
};
